import { colInitialsImage } from "@components-common/tables";
import { FC } from "react";
import { CustomInput, Table } from "taltech-styleguide";

type Props = {
  tableItems: any[];
  columns: {
    header: string;
    accessor: string;
  }[];
  selected?: string[];
  setSelected?: (selected: string[]) => void;
  hasEdit?: boolean;
};

export const TableGroupsSelection: FC<Props> = ({
  tableItems,
  columns,
  selected,
  setSelected,
  hasEdit = false,
}) => {
  const onSelectioChange = (id: string) => {
    if (selected !== undefined && setSelected !== undefined) {
      if (selected.includes(id)) {
        setSelected(selected.filter((s) => s !== id));
      } else {
        setSelected([...selected, id]);
      }
    }
  };

  return (
    <Table className="table-hover text-sm">
      <thead>
        {columns.map((column) => (
          <th key={column.accessor}>
            <div className="table__header">{column.header}</div>
          </th>
        ))}
      </thead>
      <tbody>
        {tableItems.map((user: any, index: number) => (
          <tr key={user.user.id + index}>
            <td className="ebd-initials-first">
              {hasEdit && (
                <CustomInput
                  type="checkbox"
                  checked={selected!.includes(user.userId)}
                  onChange={() => onSelectioChange(user.userId)}
                />
              )}
            </td>
            {columns.slice(1).map((column) => (
              <>
                {column.accessor === "displayName" ? (
                  <div key={column.accessor} className="d-flex align-items-center gap-2">
                    {colInitialsImage(user.user)}
                    <span>{user[column.accessor]}</span>
                  </div>
                ) : (
                  <td key={column.accessor}>{user[column.accessor]}</td>
                )}
              </>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
